export default __webpack_public_path__ + "static/media/element_spec_52.e6288b3f.webp";